import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { PlayCircleIcon } from "@heroicons/react/24/solid";
import { Select } from "@/components/ui/select/select";
import { SelectItem } from "@/components/ui/select/select-item";

const METRICS = ["Hook", "Visual ease", "Hold"];
const PERCENT_TICKS = [0, 20, 40, 60, 80, 100];

/*
 * VideoReportsSkeleton component
 * Skeleton component used while a video study's reports overview is loading
 */
export const VideoReportsSkeleton = () => {
  /* Render */
  return (
    <div className="flex flex-col gap-4">
      {/* Summary */}
      <div className="flex flex-col gap-3">
        <h2 className="text-base font-semibold opacity-70">Summary</h2>
        <div className="flex flex-col gap-2">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="skeleton h-9 w-full rounded-2xl" />
          ))}
        </div>
      </div>

      {/* Benchmark */}
      <div className="flex flex-col gap-4">
        <p className="font-semibold">Benchmark</p>
        <div className="grid grid-cols-[1fr_420px] gap-x-8 gap-y-4 items-start px-4">
          <div className="flex flex-col gap-2">
            <div className="skeleton h-28 w-full rounded-lg" />
            <div className="flex justify-between w-full text-[8px] text-base-content/60">
              {PERCENT_TICKS.map((tick) => (
                <span key={tick}>{tick}%</span>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-1">
              <p className="text-sm font-semibold text-base-content/60">Applied benchmark</p>
              <InformationCircleIcon className="size-4 text-base-content/50" />
            </div>
            <div className="skeleton h-9 w-full rounded-lg" />
          </div>
        </div>
      </div>

      {/* Assets */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <h2 className="text-base font-semibold opacity-70">Assets</h2>
          <Select defaultValue="desc" onChange={() => {}} disabled>
            <SelectItem value="desc">Sort by: Highest score</SelectItem>
            <SelectItem value="asc">Sort by: Lowest score</SelectItem>
          </Select>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="card bg-base-100 border-2 border-base-300 rounded-2xl">
              {/* Media placeholder with play button */}
              <div className="skeleton min-h-44 max-h-44 w-full rounded-t-2xl rounded-b-none flex items-center justify-center">
                <PlayCircleIcon className="size-16 text-base-content/20" />
              </div>

              {/* Content */}
              <div className="px-4 py-5 flex flex-col gap-4">
                <div className="flex items-center justify-between">
                  <p className="font-semibold">Attention</p>
                  <div className="skeleton h-4 w-10 rounded-full" />
                </div>

                {METRICS.map((metric) => (
                  <div key={metric} className="flex items-center justify-between gap-2">
                    <p className="opacity-70 text-sm">{metric}</p>
                    <div className="skeleton h-4 w-2/5 rounded-lg" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
